import React, { useEffect, useState } from "react";
import { Box, LinearProgress, Typography } from "@material-ui/core";
import { DeleteSweep as DeleteSweepIcon } from "@material-ui/icons";

import api from "../../services/api";

const CompanyMaintenanceNotice = () => {
  const [job, setJob] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadStatus = async () => {
      try {
        const { data } = await api.get("/companies/maintenance/current");
        if (mounted) setJob(data);
      } catch (_) {
        // O aviso é complementar e nunca deve interromper o uso do sistema.
      }
    };

    loadStatus();
    const timer = setInterval(loadStatus, 2500);
    return () => {
      mounted = false;
      clearInterval(timer);
    };
  }, []);

  if (!job || job.kind !== "cleanup" || !["queued", "running"].includes(job.status)) {
    return null;
  }

  const percentage = job.total > 0 ? Math.min(100, (job.processed / job.total) * 100) : 0;

  return (
    <Box
      mx={1}
      mb={1}
      px={2}
      py={1.5}
      borderRadius={12}
      color="#fff"
      style={{
        background: "linear-gradient(135deg, #8f2434 0%, #d64c5d 100%)",
        boxShadow: "0 10px 28px rgba(143, 36, 52, .24)",
      }}
    >
      <Box display="flex" alignItems="center" mb={0.75}>
        <DeleteSweepIcon style={{ marginRight: 8 }} />
        <Typography variant="body2" style={{ fontWeight: 800 }}>
          Manutenção protegida: os atendimentos desta empresa estão sendo limpos
        </Typography>
      </Box>
      <LinearProgress
        variant={job.total > 0 ? "determinate" : "indeterminate"}
        value={percentage}
        style={{ height: 6, borderRadius: 6 }}
      />
      <Typography variant="caption" style={{ display: "block", marginTop: 6, opacity: 0.9 }}>
        {job.phase} • Processados: {job.processed || 0} • Restantes: {job.remaining || 0}
      </Typography>
    </Box>
  );
};

export default CompanyMaintenanceNotice;
